import createContext from 'contexts/create-context';
import * as React from 'react';

import {
  type AllGeneralSettings as AllGeneralSettingsType,
  useAllGeneralSettings as useAllGeneralSettingsQuery,
} from './models';
import { nullthrows } from '../../utils/invariant';
import { useMinimalGeneralSettings } from '../../contexts/minimal-settings-context';
import { SpinnerBlock } from '../../components/Spinner';

export type AllGeneralSettings = AllGeneralSettingsType;

interface ProviderValue {
  settings: AllGeneralSettings;
  refreshData: () => void;
}

const [useContext, ReactProvider] = createContext<ProviderValue>();

interface IAllGeneralSettingsProviderProps {
  children?: React.ReactNode;
}

export const AllGeneralSettingsProvider: React.FC<IAllGeneralSettingsProviderProps> = (props) => {
  const { children } = props;
  const { data, isLoading, mutate: refreshData } = useAllGeneralSettingsQuery();
  const { refreshData: refreshMinimalData } = useMinimalGeneralSettings();

  if (isLoading) {
    return <SpinnerBlock message="Loading..." className="h-screen" />;
  }

  return (
    <ReactProvider
      value={{
        settings: nullthrows(data, 'General settings not found'),
        refreshData: () => {
          refreshMinimalData();
          refreshData();
        },
      }}
    >
      {children}
    </ReactProvider>
  );
};

export const useAllGeneralSettings = useContext;
